import { LocaleEnum } from '@systemeio/ui'
import httpClient from '../utils/http-client'

export function changeLanguage(locale: LocaleEnum) {
  return httpClient.post('/api/user/change-language', { language: locale })
}
